import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage'; // your landing page component
import BlogPage from './pages/BlogPage';
import BlogArticle from './pages/BlogArticle';
import AdminBlog from './pages/AdminBlog';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminContacts from './pages/AdminContacts';
import AdminBlogStats from './pages/AdminBlogStats';
import AdminBlogAnalytics from './pages/AdminBlogAnalytics';
import AdminMainOverview from './pages/AdminMainOverview';
import AdminBlogDashboard from './pages/AdminBlogDashboard';
import AdminTodoDashboard from './pages/AdminTodoDashboard';
import AdminSchoolDashboard from './pages/AdminSchoolDashboard';
import AdminAssignmentTracker from './pages/AdminAssignmentTracker';
import AdminProgressAnalytics from './pages/AdminProgressAnalytics';
import PublicSubmission from './pages/PublicSubmission';
import { BlogProvider } from './BlogContext';
import { AuthProvider } from './AuthContext';
import PodcastRSSMaker from './pages/PodcastRSSMaker';
import GPAPage from './pages/GPAPage';
import LowestGradePage from './pages/LowestGradePage';
import FullWidthGradeCharts from './pages/FullWidthGradeCharts';
import PTSBusinessCardRedirect from './pages/PTSBusinessCardRedirect';


function App() {
  return (
    <AuthProvider>
      <BlogProvider>
        <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/blog/:id" element={<BlogArticle />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/submit" element={<PublicSubmission />} />
          <Route path="/gpa" element={<GPAPage />} />
          <Route path="/lowest-grade" element={<LowestGradePage />} />
          <Route path="/pts-business-card" element={<PTSBusinessCardRedirect />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/blog-dashboard" element={<AdminBlogDashboard />} />
          <Route path="/admin/todo-dashboard" element={<AdminTodoDashboard />} />
          <Route path="/admin/school-dashboard" element={<AdminSchoolDashboard />} />
          <Route path="/admin/assignment-tracker" element={<AdminAssignmentTracker />} />
          <Route path="/admin/progress-analytics" element={<AdminProgressAnalytics />} />
          <Route path="/admin/full-charts" element={<FullWidthGradeCharts />} />
          <Route path="/admin/blog" element={<AdminBlog />} />
          <Route path="/admin/blog-stats" element={<AdminBlogStats />} />
          <Route path="/admin/blog-analytics/:id" element={<AdminBlogAnalytics />} />
          <Route path="/admin/contacts" element={<AdminContacts />} />

          {/* Legacy Routes */}
          <Route path="/create-blog-article" element={<AdminBlog />} />
          <Route path="/RSS-Maker" element={<PodcastRSSMaker />} />
        </Routes>
      </Router>
    </BlogProvider>
    </AuthProvider>
  );
}

export default App;